"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-wrap justify-center gap-4 md:gap-8">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-16 bg-primary/10 animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-wrap justify-center gap-4 md:gap-8">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[12px] font-sans text-primary/70 hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-[hsl(0,0%,96%)] border-t border-border py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-8 md:flex-row md:justify-between md:gap-6">
        <div className="flex-shrink-0">
          <Link to="/">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/robotaxinu_logo.png" alt="RobotaxiNU Logo" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        <nav className="flex-1 flex justify-center" aria-label="Footer Navigation">
          <MenuProvider menu_id="17">
            <FooterMenuConsumer />
          </MenuProvider>
        </nav>

        <div className="flex-shrink-0 text-center md:text-right">
          <p className="text-[12px] font-sans text-primary/70">
            &copy; {currentYear} RobotaxiNU. Alla rättigheter förbehållna.
          </p>
        </div>
      </div>
    </section>;
}